import * as React from "react";
import Icon, { TIconNames } from "~/components/icons/icon";
import classNames from "classnames";

interface ISwiperButtonProps {
    className?: string;
    direction: "LEFT" | "RIGHT";
    onClick?: () => void;
}

const SwiperButton: React.SFC<ISwiperButtonProps> = ({ className, direction, onClick }) => {
    const baseClass = "swiper-button";
    const classes = classNames(baseClass, className, {
        [`${baseClass}--right`]: direction === "RIGHT",
        [`${baseClass}--left`]: direction === "LEFT"
    });
    const iconId: TIconNames = direction === "RIGHT" ? "icon_16_arrow-right" : "icon_16_arrow-left";

    return (
        <button tabIndex={0} className={classes} onClick={onClick}>
            <Icon className="swiper-button__icon" iconId={iconId} />
        </button>
    );
};

export default SwiperButton;
